import { ActionType } from '../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../core/api/rsaa';
import { Endpoints } from '../../../core/api/endpoints';
import { AppState } from '../../../core/redux/appState';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../core/api/module';
import * as R from 'ramda';
import { Rater } from './models';


const KEY_ACTION = ActionType.UpdateRaterRequest;
const ACTIONS    = [
  ActionType.UpdateRaterRequest,
  ActionType.UpdateRaterResponse,
  ActionType.UpdateRaterError,
];


type Payload = Rater;


type Meta = {
  projectId: number;
  participantId: number;
  raterId: number;
};


export const updateRaterAction = (
  projectId: number,
  participantId: number,
  raterId: number,
  email?: string,
  undelivered?: boolean,
  firstName?: string,
  lastName?: string,
  levelId?: number,
  languageId?: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.EditRater,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      projectId:     projectId,
      participantId: participantId,
      raterId:       raterId,
      email:         email,
      undelivered:   undelivered,
      firstName:     firstName,
      lastName:      lastName,
      levelId:       levelId,
      languageId:    languageId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(
      ACTIONS,
      {
        projectId: projectId, participantId: participantId, raterId: raterId,
      },
    ),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION, `${projectId}-${raterId}`),
  },
);


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.projectId}-${action.meta.raterId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  const projectId = action.meta.projectId;
  const raterId   = action.meta.raterId;
  const withRaterDeleted = R.dissocPath(['projectRaters', `${projectId}`, `${raterId}`], successState) as AppState;

  return R.assocPath(
    ['projectRaters', `${payload!.projectId}`, `${payload!.raterId}`],
    payload,
    withRaterDeleted,
  );
};


export const updateRaterReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
